<form class="criteria-form" #searhCriteriaForm="ngForm">

  <div class="banner-section">
    <!-- <h3>Ma recherche pour {{ selectedBusinessLine == CarBusinessLine.BUY ? 'acheter' : 'louer' }} </h3> -->
    <h4>Ma recherche</h4>

    <div class="filter-button" >
      <mat-label>Filtres</mat-label>
      <button mat-button class="simple-button-{{selectedBusinessLine!.toLowerCase()}}" matTooltipPosition="above" matTooltip="Filtres" (click)="toggleShowCriteria()">
        <mat-icon>tune</mat-icon>
      </button>
    </div>
  </div>

  <div class="criterias-section" [style.display]="showCriteriaPanel ? 'block' : 'none'" (window:resize)="onResize($event)">
    <div class="criterias-fields">

      <!-- <mat-form-field >
      <mat-label>Vente/Location</mat-label>
      <mat-select name="businessLines" (selectionChange)="onBusinessLineChange()" [(value)]="selectedBusinessLine">
        <mat-option *ngFor="let line of businessLinesBD" [value]="line" >{{line}}</mat-option>
      </mat-select>
    </mat-form-field> -->

    <mat-form-field>
      <mat-label>Marques</mat-label>
      <mat-select name="makes"  multiple (selectionChange)="onMakesChange($event.value)" [(ngModel)]="selectedMakes">
        @for (make of (makes$ | async)!; track make; let i = $index) {
          <mat-option [value]="make" >{{make.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field *ngIf = "searchForm.value.makes !=''"> -->
    @if (selectedBusinessLine === 'BUY'  && carCriteria.makes.length!==0) {
      <mat-form-field>
        <mat-label>Modèles</mat-label>
        <mat-select name="models"  [disabled]="carCriteria.makes.length===0" multiple (selectionChange)="onModelsChange($event.value)" [(ngModel)]="selectedModels">
          @for (model of (models$ | async)!; track model) {
            <mat-option [value]="model" >{{model.makeName}} {{model.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <!-- <mat-form-field *ngIf = "searchForm.value.makes !=''"> -->
    @if (selectedBusinessLine === 'BUY' && carCriteria.models.length!==0) {
      <mat-form-field>
        <mat-label>Versions</mat-label>
        <mat-select name="versions"  [disabled]="carCriteria.models.length===0" multiple (selectionChange)="onVersionsChange($event.value)" [(ngModel)]="selectedVersions">
          @for (version of (versions$ | async)!; track version) {
            <mat-option [value]="version" >{{version.makeName}} {{version.modelName}} {{version.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  <!--
  <div >
    <mat-form-field *ngIf="selectedBusinessLine === 'RENTAL'">
      <mat-label>Date début </mat-label>
      <input required matInput [matDatepicker]="picker" name ="startDate" (dateChange)="onCriteriaChange()" >
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf="selectedBusinessLine === 'RENTAL'">
      <mat-label>Date fin </mat-label>
      <input required matInput [matDatepicker]="picker1" name ="endDate" (dateChange)="onCriteriaChange()" >
      <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
  </div>
  -->
  <div class="slider">
    @if (selectedBusinessLine === 'RENT') {
      <mat-form-field>
        <mat-label> Dates demandées</mat-label>
        <mat-date-range-input matInput [rangePicker]="picker2" [dateFilter]="filterPastDates">
          <input required matStartDate placeholder="Début" name="start" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="carCriteria.startDate" >
          <input required matEndDate placeholder="Fin" name="end" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="carCriteria.endDate" >
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-date-range-picker #picker2></mat-date-range-picker>
      </mat-form-field>
    }
  </div>

  @if (selectedBusinessLine === 'BUY') {
    <div class="slider">
      <span>
        <mat-label>
          Année <br />
          <span class="info">
            (De {{carCriteria.yearMin}} à {{carCriteria.yearMax}})
          </span>
        </mat-label>
        <mat-slider [disabled]="disabled"
          [max]="yMax"
          [min]="yMin"
          [step]="1"
          [discrete]="thumbLabel"
          [showTickMarks]="showTicks"
          [displayWith]="formatSliderLabel"
          (slideend)="onCriteriaChange()"
          (pointerup)="onCriteriaChange()">
          <input matSliderStartThumb name="yearMin" [(ngModel)]="carCriteria.yearMin">
          <input  matSliderEndThumb name="yearMax" [(ngModel)]="carCriteria.yearMax">
        </mat-slider>
      </span>
    </div>
  }

  <div class="slider">
    <div >

      <mat-label>
        Prix <br />
        <span class="info">
          ({{formatSliderLabel (carCriteria.priceMin)}} FCFA - {{formatSliderLabel(carCriteria.priceMax)}} FCFA)
        </span>
      </mat-label>

      <mat-slider [disabled]="disabled"
        [max]="pMax"
        [min]="pMin"
        [step]="step"
        [discrete]="thumbLabel"
        [showTickMarks]="showTicks"
        [displayWith]="formatSliderLabel"
        (slideend)="onCriteriaChange()"
        (pointerup)="onCriteriaChange()">

        <input matSliderStartThumb name="priceMin" [(ngModel)]="carCriteria.priceMin">
        <input  matSliderEndThumb name="priceMax" [(ngModel)]="carCriteria.priceMax">

      </mat-slider>
    </div>
  </div>

  <div class="criterias-fields">
    <mat-form-field >
      <mat-label> Pays</mat-label>
      <mat-select matInput id="country-select" multiple [(value)]="selectedCountryCodes" (selectionChange)="updateCountries($event)" >
        <mat-select-trigger class = "mini-flags">

          @for (code of selectedCountryCodes; track code; let i = $index) {
            <span class = "mini-flag">
              <img  mat-card-image src="assets/images/country-flags/{{code}}.png" alt="{{code}}">  &nbsp;
            </span>
          }

        </mat-select-trigger>

        @for (code of countryCodeOptions; track code; let i = $index) {
          <mat-option matOption class = "country-option" [value]="code" >
            <span class = "mini-flag">
              <img  mat-card-image src="assets/images/country-flags/{{code}}.png" alt="{{code}}">
            </span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <!-- Cities: <h6 *ngFor="let city of citiesBD"  >{{city}}</h6> -->
    @if (selectedCountryCodes.length!==0) {
      <mat-form-field appearance ="outline" >
        <mat-label>Villes</mat-label>
        <mat-select name="cities"  [disabled]="selectedCountryCodes.length===0" multiple (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.cities">
          @for (city of citiesBD; track city) {
            <mat-option [value]="city" >{{city}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }


    @if (selectedBusinessLine === 'BUY') {
      <mat-form-field>
        <mat-label>Boîtes</mat-label>
        <mat-select name="gearBoxes"  multiple (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.gearBoxes">
          @for (gb of gearboxesBD; track gb) {
            <mat-option [value]="gb" >{{gb}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (selectedBusinessLine === 'BUY') {
      <mat-form-field>
        <mat-label>Carburants</mat-label>
        <mat-select name="fuels"  multiple (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.fuels">
          @for (ft of fuelTypesBD; track ft) {
            <mat-option [value]="ft" >{{ft}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

  </div>

</div>

@if (showCriteriaPanel) {
  <div class="submit-section" >
    <button type="submit" mat-button (click)="saveAlert()" class="cta-button-{{carCriteria.businessLine?.toLowerCase()}}">
      <mat-icon>add_alert</mat-icon>
    </button>
    <button type="submit" mat-button (click)="submitSearchForm()" class="cta-button-{{carCriteria.businessLine?.toLowerCase()}}" [disabled]="!searhCriteriaForm.form.valid">
      <mat-icon>search</mat-icon>
      @if ((fetchingPreview$ | async)) {
        <span style="text-align:center">
          <mat-spinner  [diameter]="20"></mat-spinner>
        </span>
      }
      @if (!(fetchingPreview$ | async)) {
        <span>
          {{ (previewTotalCount$ | async) }} véhicules
        </span>
      }
    </button>
  </div>
}

@if (showCriteriaPanel) {
  <button type="submit" mat-button (click)="saveAlert()" class="simple-button-{{carCriteria.businessLine?.toLowerCase()}}">
    <mat-icon>add_alert</mat-icon>
    <span>Enregistrer la recherche</span>
  </button>
}

@if (showCriteriaPanel) {
  <button type="submit" mat-button (click)="resetSearch()" class="simple-button-{{carCriteria.businessLine?.toLowerCase()}}" >
    <mat-icon>autorenew</mat-icon>
    <span> Réinitialiser les filtres </span>
  </button>
}

</form>


